import React from "react";
import { MdOutlineFacebook } from "react-icons/md";
import { AiFillInstagram } from "react-icons/ai";
import { RiWhatsappFill } from "react-icons/ri";
import althilogo from "../assets/althilogo.png";
import { FaArrowRightLong } from "react-icons/fa6";

const footerData = [
  {
    links: [
      { "": "" },
      { "": "" },
      { "": "" },
      {
        discription:
          "Follow us on your favorite platforms to stay updated on new arrivals, academy updates, and exclusive offers",
      },
      {
        icons: [
          {
            icon: MdOutlineFacebook,
            url: "https://www.facebook.com/share/19Gck9kD7a/?mibextid=wwXIfr",
          },
          {
            icon: AiFillInstagram,
            url: "https://www.instagram.com/kosmos_sports_oman/?hl=en",
          },
          { icon: RiWhatsappFill, url: "" },
        ],
      },
    ],
  },
  {
    title: "Quick Links",
    links: [
      { text: "Home", url: "/" },
      { text: "Contact Us", url: "/contactus" },
      { text: "Our Products", url: "/accessories" },
      { text: "Kosmos Badminton Academy", url: "kbaacademy" },
      { text: "Book Your Slot", url: "/slotpage" },
    ],
  },
  {
    title: "Contact Emails",
    links: [
      {
        positiontocontact: "General Enquiries :",
        mail: " adminkba@example.com",
      },
      { positiontocontact: "Kosmos Badminton Academy :", mail: "kba@example.com" },
      { positiontocontact: "Ruwi Branch :", mail: "kosmosruwi@example.com" },
      {
        positiontocontact: "Azaiba Branch :",
        mail: "kosmosazaiba@example.com",
      },
      { positiontocontact: "Riaz Sports :", mail: "riazsports@example.com" },
    ],
  },
  {
    title: "For Updates",
    links: [
      {
        contactToupdate: [RiWhatsappFill, FaArrowRightLong],
        updatebtn: "JOIN OUR CHANNEL",
        updatedes:
          "Receive quick updates on court bookings, academy notices, offers, and more—directly on WhatsApp.",
        url: "",
      },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0C0C0C] text-[#FFFFFF] pb-20 text-xs font-intertight tracking-wide">
      <div className="custom-border"></div>
      <div
        style={{
          position: "absolute",
          fontSize: "1.3rem",
          fontFamily: "League Gothic",
          borderBottom: "1px solid gray",
          paddingBottom: "40px",
          marginTop: "40px",
          marginLeft: "30px",
        }}
      >
        <h1>
          LET US <span style={{ color: "#F58220" }}>CONNECT </span>HERE
        </h1>
      </div>
      <div
        className="max-w-1xs mx-auto pl-8 pt-20 grid grid-cols-4
  [@media(max-width:1086px)]:grid-cols-2
  [@media(max-width:700px)]:grid-cols-1
  gap-x-8 gap-y-16"
      >
        {footerData.map((items) => (
          <div key={items.title}>
            <h3 className="text-lg font-semibold mb-4 text-[#F58220]">
              {items.title}
            </h3>
            <ul className="space-y-1 text-[#FFFFFF99] text-base">
              {items.links.map((link, index) => (
                <ul key={index} className="hover:text-white cursor-pointer">
                  <a
                    className="text-[#FFFFFF99] hover:text-white"
                    style={{ textDecoration: "none", hover: "white" }}
                    href={link.url}
                  >
                    {" "}
                    {link.text}
                  </a>{" "}
                  <small style={{ color: "gray" }}> {link.discription}</small>
                  <span
                    style={{ color: "white", display: "flex", gap: "15px" }}
                  >
                    {link.icons &&
                      link.icons.map(({ icon: Icon, url }, idx) => (
                        <a
                          key={idx}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: "white" }}
                        >
                          <Icon
                            size={40}
                            style={{
                              backgroundColor: "#F58220",
                              borderRadius: "25px",
                              padding: "8px",
                            }}
                          />{" "}
                        </a>
                      ))}
                  </span>
                  <span style={{ color: "white" }}>
                    {link.positiontocontact}
                  </span>{" "}
                  {link.mail}
                  {link.contactToupdate &&
                    (() => {
                      const Icon1 = link.contactToupdate[0];
                      const Icon2 = link.contactToupdate[1];
                      return (
                        <div
                          onClick={() => window.open(link.url, "_blank")}
                          className="flex items-center w-fit rounded-full ms:overflow-hidden shadow-lg bg-white"
                          style={{ marginBottom: "20px" }}
                        >
                          <span className="flex items-center gap-2 bg-[#F58220] px-5 py-3 md:p-2 xs:p-1 rounded-full text-white">
                            {Icon1 && <Icon1 size={24} />}
                            <span
                              className="text-md"
                              style={{ fontFamily: "League Gothic" }}
                            >
                              {link.updatebtn}
                            </span>
                          </span>
                          <span className="text-[#F58220] px-4 py-3 md:p-2 xs:p-1 rounded-r-full">
                            {Icon2 && <Icon2 size={15} />}
                          </span>
                        </div>
                      );
                    })()}
                  <small style={{ width: "300px", color: "gray" }}>
                    {link.updatedes}
                  </small>
                </ul>
              ))}
            </ul>
          </div>
        ))}

        <div
          style={{
            color: "gray",
            fontSize: "1.1rem",
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          Powered by
          <a
            href="https://www.althisolutions.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {" "}
            <img src={althilogo} alt="" style={{ width: "45px" }} />
          </a>
        </div>
      </div>
    </footer>
  );
}
